import config from 'config/Config';
import BaseApi from './BaseApi';
import { ProgramPermissions } from 'types/store/normalized';

export class ProgramPermissionsApi extends BaseApi<ProgramPermissions> {
  constructor() {
    super(`${config.get('backendURL')}v2/programs/program-permissions/query`);
  }
}
